import { AxiosRequestConfig } from 'axios'

import { ExistsInvoiceParams, InvoicePayload } from './types'

const exists = (params: ExistsInvoiceParams): AxiosRequestConfig => ({
  url: '/invoices/exists',
  method: 'GET',
  params,
})

const create = (payload: InvoicePayload): AxiosRequestConfig => ({
  method: 'POST',
  url: '/invoices?store=true',
  data: {
    series: payload.serie,
    number: payload.serieNumber,
    storeTaxId: payload.rut,
    amountInCents: payload.amount,
    date: payload.date,
    userId: payload.userId,
    currency: payload.currency,
    adminId: payload.adminId,
  },
})

export const InvoiceApi = {
  exists,
  create,
}
